<script setup lang="ts">
import { DropdownMenu } from "radix-vue/namespaced";
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";

defineProps<{
  isActive?: boolean;
}>();

const { data: user } = useUser();
</script>

<template>
  <DropdownMenu.Item :asChild="true">
    <button
      :class="
        twMerge(
          'text-galbani hover:bg-galbani/10 flex cursor-pointer items-center justify-center gap-2 py-1 font-medium',
          !isActive && 'bg-white',
          isActive && user?.current_mechanic !== 'lactel' && 'bg-galbani/10',
          isActive && user?.current_mechanic === 'lactel' && 'bg-lactel-blue/10',
          user?.current_mechanic === 'lactel' && 'text-lactel-blue hover:bg-lactel-blue/10',
          typeof $props.class === 'string' ? $props.class : '',
        )
      "
    >
      <slot />
    </button>
  </DropdownMenu.Item>
</template>
